import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatTabsModule } from '@angular/material/tabs';
import { NgClass } from '@angular/common';
import { MatHint } from '@angular/material/form-field';

@Component({
  selector: 'formly-field-group',
  template: `
    <div>
      @if (field.props.label) {
        <h3 class="mb-2">{{ field.props.label }}</h3>
      }
      @for (fieldItem of field.fieldGroup; track $index) {
        <formly-field [field]="fieldItem"></formly-field>
      }
      @if (field.props.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
  `,
  imports: [FormlyModule, MatTabsModule, MatHint],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldGroup extends FieldType {}
